import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

import { Tags } from 'root/admin/components';

import store from 'root/admin/store';
import { Loader, TabMenu, MenuItem } from '@smartplatform/ui';

const menuItems = [
	{
		label: 'Фоторепортажи',
		id: 'galleries',
	},
	{
		label: 'Категории',
		id: 'tags',
	},
];
@observer
export default class Gallery extends React.Component {
	@observable tab;

	switchTab = record => {
		this.tab = record.id;
		this.props.history.push(`/admin/galleries/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		const rootPath = '/admin/galleries';
		if (store.route.path === rootPath) {
			return <Redirect to={`${rootPath}/galleries`} />;
		}
		console.log('gallery');

		return (
			<div>
				<TabMenu>
					{menuItems.map(record => (
						<MenuItem
							key={`category-${record.id}`}
							label={record.label}
							onClick={() => this.switchTab(record)}
							active={store.ui.page === record.id}
						/>
					))}
				</TabMenu>

				<Route
					exact
					path={`${rootPath}/galleries`}
					component={() => <List rootPath={rootPath} tabName="galleries" />}
				/>
				<Route
					exact
					path={`${rootPath}/galleries/:id`}
					component={() => <Edit rootPath={rootPath} tabName="galleries" />}
				/>
				<Route path={`${rootPath}/tags`} component={() => <Tags model="gallery" />} />
			</div>
		);
	}
}
